export default __webpack_public_path__ + "static/media/folders_dashboard.f2d4dd86.svg";